import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPdfFileicon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6 2.75h7.25L18.25 7.75V21.25H6V2.75Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13.25 2.75V7.75h5",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	})]
});
export default SvgPdfFileicon;
